import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import PropTypes from "prop-types";
import MenuLink from "modules/common/components/MenuLink";

const { Flex, Text } = Chakra;

const Menu = ({ label, menu }) => {
  const translations = useTranslations();

  return (
    <Flex direction="column">
      {label && (
        <Text
          textTransform="uppercase"
          fontWeight="semibold"
          fontSize="sm"
          mb={4}
          letterSpacing="0.25px"
          data-testid="footer-category"
        >
          {translations(label)}
        </Text>
      )}
      <Flex direction="column" role="menu" mt={!label ? 4 : 0}>
        {menu &&
          menu.map((item) => {
            const { label: menuItemLabel } = item;

            return (
              <MenuLink
                key={menuItemLabel}
                menuItem={item}
                variant="footerLight"
                fontSize="sm"
                mb={5}
                data-testid="footer-elements"
              />
            );
          })}
      </Flex>
    </Flex>
  );
};

export default Menu;

Menu.propTypes = {
  label: PropTypes.string,
  menu: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Menu.defaultProps = {
  label: "",
};
